<template>
  <PopoverMenu :data-test-id="`${entityType}-detail-card-menu`">
    <template #trigger>
      <slot name="trigger">
        <Btn :data-test-id="`${entityType}-detail-card-button`" color="grey" icon>
          <MoreIcon16 />
        </Btn>
      </slot>
    </template>

    <template #items-list>
      <PopoverMenuSection v-if="hasSlot.options">
        <slot name="options" />
      </PopoverMenuSection>

      <PopoverMenuSection v-if="hasSlot.tools" divider>
        <slot name="tools" />
      </PopoverMenuSection>

      <PopoverMenuSection v-if="hasSlot.layout" :title="$t('sourceDetail.layout')" divider>
        <slot name="layout" />
      </PopoverMenuSection>

      <PopoverMenuSection divider>
        <slot name="main" />
      </PopoverMenuSection>

      <PopoverMenuSection>
        <PopoverMenuText>
          <UserActivityCombined
            :user-created="source.createdBy"
            :user-updated="source.updatedBy"
            :date-created="source.createdAt"
            :date-updated="source.updatedAt"
            :quotation-count="source.quotations?.length"
            :code-count="source.codes?.length"
          />
        </PopoverMenuText>
      </PopoverMenuSection>

      <PopoverMenuSection divider>
        <ConfirmModal
          v-slot="{ openModal }"
          class="detail-header-delete-button"
          :title="$t(`${entityType}Detail.confirmDelete.title`)"
          :button-text="$t(`${entityType}Detail.confirmDelete.title`)"
          :message="$t(`${entityType}Detail.confirmDelete.text`)"
          destructive
        >
          <PopoverMenuItem
            :primary-text="$t('action.delete')"
            destructive
            @click="() => handleDeleteButtonClick(openModal)"
          >
            <template #info-icon>
              <DeleteIcon16 />
            </template>
          </PopoverMenuItem>
        </ConfirmModal>
      </PopoverMenuSection>
    </template>
  </PopoverMenu>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import ConfirmModal from '@components/ConfirmModal.vue';
import MoreIcon16 from '@components/Icons/MoreIcon16.vue';
import DeleteIcon16 from '@components/Icons/DeleteIcon16.vue';
import { Memo, Report, Source } from '@/graphql/operations.gen';
import { hasSlotContent } from '@components/slots';

export default defineComponent({
  emits: { 'delete-entity': null },
  name: 'DetailHeaderMenu',

  components: {
    ConfirmModal,
    DeleteIcon16,
    MoreIcon16,
  },

  props: {
    source: {
      type: Object as PropType<Report | Memo | Source>,
      required: true,
    },

    entityType: {
      type: String,
      required: true,
      validator: (value) => ['source', 'memo', 'report'].includes(value),
    },
  },

  methods: {
    handleDeleteButtonClick(openModalFunction: Function) {
      openModalFunction(() => this.$emit('delete-entity'));
    },
  },

  computed: {
    hasSlot() {
      return {
        options: hasSlotContent(this.$slots.options, {}),
        layout: hasSlotContent(this.$slots.layout, {}),
        tools: hasSlotContent(this.$slots.tools, {}),
      };
    },
  },
});
</script>
